import React, { useContext, useState } from "react";
import { generatePath, Navigate, useLocation } from "react-router-dom";
import track from "react-tracking";

import LoginView from "components/LoginView";
import { PAGE_PATHS } from "config/routes";
import { SessionContext } from "contexts";
import useEffectOnce from "hooks/useEffectOnce";
import { usePageTracking } from "utils/tracking";

type LoginLocationState = Record<string, string>;

const LoginPage: React.FC = () => {
  const { user, authRedirect, setAuthRedirect } = useContext(SessionContext);
  const location = useLocation();
  const locationState = location.state as LoginLocationState;

  const [from] = useState<string>(locationState?.from ? locationState?.from : generatePath(PAGE_PATHS.HOME_PAGE));
  usePageTracking();

  useEffectOnce(() => {
    if (user && authRedirect) {
      setAuthRedirect(null);
    }
  });

  if (user === null) {
    return <LoginView />;
  } else {
    if (authRedirect) {
      return <Navigate to={authRedirect} />;
    } else {
      return <Navigate to={{ pathname: from }} />;
    }
  }
};

export default track({ page_type: "Login" })(LoginPage);
